import { MyHistoryTypes } from './types';

export const getFollowups = (
  pageFollowup: number,
  filtro: string,
  urlFollowup: string,
  companyId: number,
  cnpj?: string | any,
  startDate?: any,
  endDate?: any,
) => ({
  types: [
    MyHistoryTypes.GET_FOLLOWUPS_REQUEST,
    MyHistoryTypes.GET_FOLLOWUPS_SUCCESS,
    MyHistoryTypes.GET_FOLLOWUPS_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`${urlFollowup}`, {
      params: { page: pageFollowup, filtro, companyId, startDate, endDate, cnpj },
    }),
});

export const getMyHistory = (
  page: number,
  filtro?: string,
  startDate?: string | null,
  endDate?: string | null,
) => ({
  types: [
    MyHistoryTypes.GET_MY_HISTORY_REQUEST,
    MyHistoryTypes.GET_MY_HISTORY_SUCCESS,
    MyHistoryTypes.GET_MY_HISTORY_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/my_history', {
      params: { page, filtro, startDate, endDate },
    }),
});

export const list_itens = (bidding_id: number) => {
  return {
    types: [
      MyHistoryTypes.GET_LIST_ITENS_REQUEST,
      MyHistoryTypes.GET_LIST_ITENS_SUCCESS,
      MyHistoryTypes.GET_FOLLOWUPS_FAILURE,
    ],
    promise: (client: any) => client.get('/my_history/list_itens', { params: { bidding_id } }),
  };
};
